import React from 'react';

import LoadingContainer from '../../../../../../components/LoadingContainer';

export interface Props {
  isLoading?: boolean;
  children: React.ReactNode;
}

const CompanyTabContent: React.FC<Props> = ({ isLoading, children }) => {
  if (isLoading) {
    return <LoadingContainer />;
  }

  return <>{children}</>;
};

export default CompanyTabContent;
